import { create } from 'zustand';

export interface CategoryState {
  activeCategorySlug: string | null;
  targetRotation: { y: number; x: number };
  setActiveCategory: (slug: string | null, rotation?: { y: number; x: number }) => void;
}

export const useCategoryStore = create<CategoryState>((set) => ({
  activeCategorySlug: null,
  targetRotation: { y: 0, x: 0 },
  setActiveCategory: (slug, rotation) =>
    set({
      activeCategorySlug: slug,
      targetRotation: rotation ?? { y: 0, x: 0 },
    }),
}));
